<template>
  <header class="page-intro-hero">
    <div class="page-intro-hero__inner">
      <h1 class="page-intro-hero__title">
        {{ title }}
      </h1>
      <p v-if="subtitle" class="page-intro-hero__subtitle">
        {{ subtitle }}
      </p>
    </div>
  </header>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
});
</script>